import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { useMemo } from 'react';
import { range, DOTS } from './pagination.contants';
export const usePagination = _ref => {
  let {
    totalPages,
    visiblePages,
    currentPage,
    disabledTruncation
  } = _ref;
  const paginationRange = useMemo(() => {
    const calculateElipsisVisibilty = halfMaxPages => {
      return totalPages > visiblePages ? {
        left: currentPage > visiblePages - halfMaxPages,
        right: currentPage < totalPages - halfMaxPages
      } : {
        left: false,
        right: false
      };
    };
    const incorrectValues = [totalPages < 1, visiblePages < 1, !totalPages];
    if (incorrectValues.some(Boolean)) {
      return [];
    }
    if (totalPages === 1) {
      return [1];
    }
    if (visiblePages === 1) {
      return [currentPage];
    }
    const ellipsisVisibility = calculateElipsisVisibilty((visiblePages - 1) / 2);
    if (!ellipsisVisibility.left && ellipsisVisibility.right) {
      const middlePages = range(2, visiblePages - 2);
      const middlePagesLastItem = middlePages[middlePages.length - 1];
      return disabledTruncation ? [middlePages[0] - 1].concat(_toConsumableArray(middlePages)).concat([middlePagesLastItem + 1, middlePagesLastItem + 2]) : [1].concat(_toConsumableArray(middlePages)).concat([DOTS], [totalPages]);
    }
    if (ellipsisVisibility.left && ellipsisVisibility.right) {
      const offset = Math.floor(visiblePages / 2) - 1;
      const middlePages = range(currentPage - offset + 1, currentPage + offset - 1);
      const middlePagesFirstItem = middlePages[0];
      const middlePagesLastItem = middlePages[middlePages.length - 1];
      return disabledTruncation ? [middlePagesFirstItem - 2, middlePagesFirstItem - 1].concat(_toConsumableArray(middlePages)).concat([middlePagesLastItem + 1, middlePagesLastItem + 2]) : [1].concat([DOTS], _toConsumableArray(middlePages), [DOTS], [totalPages]);
    }
    if (ellipsisVisibility.left && !ellipsisVisibility.right) {
      const startPage = totalPages - (visiblePages - 3);
      const startPages = range(startPage, totalPages - 1);
      const startPagesFirstItem = startPages[0];
      return disabledTruncation ? [startPagesFirstItem - 2, startPagesFirstItem - 1].concat([].concat(_toConsumableArray(startPages), [totalPages])) : [1].concat([DOTS], [].concat(_toConsumableArray(startPages), [totalPages]));
    }
    const middlePages = range(2, totalPages - 1);
    return [1].concat(_toConsumableArray(middlePages), [totalPages]).concat();
  }, [visiblePages, totalPages, currentPage, disabledTruncation]);
  return paginationRange;
};